import React from 'react';
import { Link } from 'react-router-dom';
import { ContactSupport, ArrowBack, Email, Phone, Language } from '@mui/icons-material';

const Contact = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50/30">
            <div className="max-w-3xl mx-auto px-6 py-12">
                <Link
                    to="/"
                    className="inline-flex items-center space-x-2 text-amber-600 hover:text-amber-700 font-medium mb-8"
                >
                    <ArrowBack className="text-lg" />
                    <span>Retour à l'accueil</span>
                </Link>
                <div className="flex items-center space-x-4 mb-8">
                    <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                        <ContactSupport className="text-white text-2xl" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold text-slate-900">Contact</h1>
                        <p className="text-slate-600">Nous contacter</p>
                    </div>
                </div>
                <div className="space-y-6">
                    <p className="text-slate-700">
                        Pour toute question technique, commerciale ou support concernant <strong>Netikash Flow</strong>,
                        vous pouvez nous joindre via les canaux ci-dessous.
                    </p>
                    <div className="grid gap-4 sm:grid-cols-1">
                        <a
                            href="mailto:support@netikash.com"
                            className="flex items-center space-x-4 p-4 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 transition-all"
                        >
                            <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center">
                                <Email className="text-amber-600" />
                            </div>
                            <div>
                                <p className="font-semibold text-slate-900">Email</p>
                                <p className="text-slate-600">support@netikash.com</p>
                            </div>
                        </a>
                        <a
                            href="tel:+243000000000"
                            className="flex items-center space-x-4 p-4 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 transition-all"
                        >
                            <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center">
                                <Phone className="text-amber-600" />
                            </div>
                            <div>
                                <p className="font-semibold text-slate-900">Téléphone</p>
                                <p className="text-slate-600">+243 XXX XXX XXX</p>
                            </div>
                        </a>
                        <a
                            href="https://www.netikash.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center space-x-4 p-4 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 transition-all"
                        >
                            <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center">
                                <Language className="text-amber-600" />
                            </div>
                            <div>
                                <p className="font-semibold text-slate-900">Site web</p>
                                <p className="text-slate-600">www.netikash.com</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
